import { Text } from '@mercator-gcp/grout';
import AIMarker from 'components/elements/AIMarker';
import { EmptyField } from 'components/elements/EmptyField';
import type { Project } from 'types';

type TProps = {
  workType?: Project['work_type'];
};

const WorkType = ({ workType }: TProps) => {
  if (!workType || workType.length === 0) {
    return <EmptyField />;
  }

  return (
    <>
      <Text>{workType.join(', ')}&nbsp;</Text>
      <AIMarker inline />
    </>
  );
};

export default WorkType;
